(() => {
  const money = (amount) => new Intl.NumberFormat(document.documentElement.lang === 'en' ? 'en-IE' : 'de-DE', {style:'currency',currency:'EUR'}).format(amount / 100);
  const fittedTitles = new WeakSet();
  function fitTitle(title) {
    const width = title.clientWidth;
    if (!width) return;
    const max = window.matchMedia('(max-width:749px)').matches ? 20 : 22;
    title.style.setProperty('--rv-title-size', `${max}px`);
    const size = Math.min(max, max * width / Math.max(width, title.scrollWidth));
    title.style.setProperty('--rv-title-size', `${Math.floor(size * 10) / 10}px`);
  }
  function initTitles(section) {
    section.querySelectorAll('[data-rv-fit-title]').forEach(title => {
      if (fittedTitles.has(title)) return;
      fittedTitles.add(title);
      fitTitle(title);
      new ResizeObserver(() => fitTitle(title)).observe(title.parentElement);
      document.fonts.ready.then(() => fitTitle(title));
    });
  }
  function sync(section) {
    if (!section) return;
    const quantity = section.querySelector('input[name="quantity"]');
    const value = Number(quantity?.value || 1);
    section.querySelectorAll('[data-rv-quantity]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.rvQuantity) === value)));
    const priceNode = section.querySelector('[data-rv-unit-price]');
    const total = section.querySelector('[data-rv-selection-total]');
    if (priceNode && total) { const next = money(Number(priceNode.dataset.rvUnitPrice) * value); if (total.textContent !== next) total.textContent = next; }
    const sticky = document.querySelector('[data-rv-sticky]');
    const submit = section.querySelector('button[name="add"]');
    if (sticky && submit) {
      const proxy = sticky.querySelector('button');
      proxy.disabled = submit.disabled || submit.classList.contains('loading');
      proxy.textContent = submit.querySelector('span')?.textContent.trim() || submit.textContent.trim();
      sticky.querySelector('[data-rv-sticky-price]').textContent = money(Number(priceNode?.dataset.rvUnitPrice || sticky.dataset.rvPrice) * value);
      sticky.dataset.visible = String(submit.getBoundingClientRect().bottom < 0);
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-rv-quantity]');
    if (button) {
      const section = button.closest('product-info');
      const input = section?.querySelector('input[name="quantity"]');
      if (!input) return;
      const value = Number(button.dataset.rvQuantity);
      const min = Number(input.min || 1), max = Number(input.max || Infinity), step = Number(input.step || 1);
      if (value < min || value > max || (value - min) % step !== 0) return;
      input.value = String(value);
      input.dispatchEvent(new Event('change', {bubbles:true}));
      sync(section);
    }
    if (event.target.closest('[data-rv-sticky] button')) {
      const section = document.querySelector('product-info[data-rv-main]');
      const submit = section?.querySelector('button[name="add"]');
      if (!submit || submit.disabled) return;
      submit.click();
      sync(section);
    }
  });
  document.addEventListener('change', event => sync(event.target.closest('product-info')));
  function init() {
    const section = document.querySelector('product-info[data-rv-main]');
    if (!section) return;
    document.body.classList.add('rv-has-sticky');
    sync(section);
    initTitles(section);
    if (!section.dataset.rvObserved) {
      section.dataset.rvObserved = 'true';
      new MutationObserver(() => {sync(section);initTitles(section);}).observe(section,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','data-rv-unit-price']});
    }
  }
  let pending = false;
  window.addEventListener('scroll', () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {sync(document.querySelector('product-info[data-rv-main]'));pending = false;});
  },{passive:true});
  document.addEventListener('shopify:section:load',init);
  init();
})();
